import React, { Component } from 'react';
import { connect } from 'react-redux';

import ScheduleEvent from './ScheduleEvent';


class ScheduleSection extends Component {
  state = {
    idSectionData: 24
  };
  createScheduleBlock() {
    const sectionData = this.props.sections.filter(section => (
      section.id == this.props.params.filter
    ));
    let beforeTime, afterTime;
    let LunchBlock, Block =[];
    if (sectionData[0].id == this.state.idSectionData) {
      beforeTime = 1475315100000;
      afterTime = 1475320500000;
      // LunchBlock = this.getMiddleDesignBlock();
    } else {
      beforeTime = 1475394000000;
      afterTime = 1475404800000;
      // LunchBlock = this.getMiddleDevelopmentBlock();
    }

    sectionData[0].scheduleViewList.map(speaker => {
      if (speaker.startTimeInMillis < beforeTime) {
        Block.push(
          <div key={speaker.roomEventShortView.idStr} className='schedule__event'>
            <div className='schedule__time'>{speaker.startTime + ' - ' + speaker.endTime}</div>
            <div className={'schedule__event-icon ' + 'schedule__event-icon_' + speaker.roomEventShortView.roomEventType}></div>
            <ScheduleEvent speakerData={speaker}>{speaker}</ScheduleEvent>
          </div>
        )
      }
    });

    Block.push(LunchBlock);

    sectionData[0].scheduleViewList.map(speaker => {
      if (speaker.startTimeInMillis >= afterTime) {
        Block.push(
          <div key={speaker.roomEventShortView.idStr} className='schedule__event'>
            <div className='schedule__time'>{speaker.startTime + ' - ' + speaker.endTime}</div>
            <div className={'schedule__event-icon ' + 'schedule__event-icon_' + speaker.roomEventShortView.roomEventType}></div>
            <ScheduleEvent speakerData={speaker}>{speaker}</ScheduleEvent>
          </div>
        )
      }
    });
    return Block;
  }
  getMiddleDesignBlock() {
    const MiddleBlock = [];
    MiddleBlock.push(
      <div key='1' className='schedule__event schedule__event_not-padding'>
        <div className='schedule__time schedule__time_padding'>15:45 - 16:30</div>
        <div className='schedule__design-block'>
          <div className={'schedule__event-icon ' + 'schedule__event-icon_Barcamp'}></div>
          <div className='room-event__event'>
            <div className='room-event__title'>Смена 1: стенды</div>
          </div>
        </div>
        <div className='schedule__design-block'>
          <div className={'schedule__event-icon ' + 'schedule__event-icon_'}></div>
          <div className='room-event__event'>
            <div className='room-event__title room-event__title_color'>Смена 2: перерыв на обед, экспертная зона</div>
          </div>
        </div>
      </div>
    );
    MiddleBlock.push(
      <div key='2' className='schedule__event schedule__event_not-padding'>
        <div className='schedule__time schedule__time_padding'>16:30 - 17:15</div>
        <div className='schedule__block-design'>
          <div className={'schedule__event-icon ' + 'schedule__event-icon_'}></div>
          <div className='room-event__event'>
            <div className='room-event__title room-event__title_color'>Смена 1: перерыв на обед, экспертная зона</div>
          </div>
        </div>
        <div className='schedule__block-design'>
          <div className={'schedule__event-icon ' + 'schedule__event-icon_Barcamp'}></div>
          <div className='room-event__event'>
            <div className='room-event__title'>Смена 2: стенды</div>
          </div>
        </div>
      </div>
    );
    return MiddleBlock;
  }
  getMiddleDevelopmentBlock() {
    const MiddleBlock = [];
    MiddleBlock.push(
      <div key='1'>
        <div className='schedule__development-block'>
          <div key='1' className='schedule__event schedule__event_min'>
            <div className='schedule__time'>13:40 - 13:55</div>
            <div className='schedule__room-event schedule__room-event_min'>
              <div className='room-event__speaker'>
                <a href={'/speaker?id=1068'} className='room-event__speaker-link'>Марина Пайч,</a>
              </div>
              <div className='room-event__speaker-job-position'>
                <a target='_blank' className='room-event__speaker-job-link' href='http://www.adcisolutions.com/'>ADCI Solutions</a>
                , Руководитель направления организационного развития
                , Омск
              </div>
              <div className='room-event__event'>
                <a href='/room-event/194' className='room-event__title-link'>Омская IT-тусовка</a>
              </div>
            </div>
          </div>
          <div key='2' className='schedule__event schedule__event_min'>
            <div className='schedule__time'>13:55 - 14:10</div>
            <div className='schedule__room-event schedule__room-event_min'>
              <div className='room-event__speaker'>
                <a href={'/speaker?id=1083'} className='room-event__speaker-link'>Александр Мишурин,</a>
              </div>
              <div className='room-event__speaker-job-position'>
                <a target='_blank' className='room-event__speaker-job-link' href='http://aciso.ru/'>МРОО «АРСИБ»</a>
                , Член АРСИБ
                , Омск
              </div>
              <div className='room-event__event'>
                <a href='/room-event/193' className='room-event__title-link'>Развитие CTF-движения в Омске</a>
              </div>
            </div>
          </div>
          <div key='3' className='schedule__event schedule__event_min'>
            <div className='schedule__time'>14:10 - 14:25</div>
            <div className='schedule__room-event schedule__room-event_min'>
              <div className='room-event__speaker'>
                <a href={'/speaker?id=1085'} className='room-event__speaker-link'>Сергей Савченко,</a>
              </div>
              <div className='room-event__speaker-job-position'>
                <a target='_blank' className='room-event__speaker-job-link' href='http://www.progschool.ru/_wp/'>ООО "Образование АйТи"</a>
                , Директор
                , Омск
              </div>
              <div className='room-event__event'>
                <a href='/room-event/192' className='room-event__title-link'>Школа программиста, учим детей и не только</a>
              </div>
            </div>
          </div>
          <div key='4' className='schedule__event schedule__event_min'>
            <div className='schedule__time'>14:25 - 14:40</div>
            <div className='schedule__room-event schedule__room-event_min'>
              <div className='room-event__event'>
                <div className='room-event__title'>Доклад уточняется</div>
              </div>
            </div>
          </div>
        </div>
        <div className='schedule__development-block schedule__development-block_min'>
          <div className=''>
            {/*<div className={'schedule__event-icon ' + 'schedule__event-icon_Barcamp'}></div>*/}
            <div className='room-event__event'>
              <div className='room-event__title room-event__title_color room-event__title_mode'>Смена 2: общение на стендах компаний</div>
            </div>
          </div>
        </div>
        <div className='schedule__development-block schedule__development-block_min'>
          <div className=''>
            {/*<div className={'schedule__event-icon ' + 'schedule__event-icon_Lunch'}></div>*/}
            <div className='room-event__event'>
              <div className='room-event__title room-event__title_mode'>Смена 3: перерыв на обед</div>
            </div>
          </div>
        </div>
      </div>
    );
    MiddleBlock.push(
      <div className='schedule__event schedule__event_not-padding'></div>
    );
    MiddleBlock.push(
      <div key='2' className='schedule__event schedule__event_not-padding'>
        <div className='schedule__time schedule__time_padding'>14:40 - 15:40</div>
        <div className='schedule__block-dev'>
          <div className={'schedule__event-icon ' + 'schedule__event-icon_Lunch'}></div>
          <div className='room-event__event'>
            <div className='room-event__title'>Смена 1 и 2: Перерыв на обед</div>
          </div>
        </div>
        <div className='schedule__block-dev'>
          {/*<div className={'schedule__event-icon ' + 'schedule__event-icon_Barcamp'}></div>*/}
          <div className='room-event__event'>
            <div className='room-event__title room-event__title_color'>Смена 3: общение на стендах компаний</div>
          </div>
        </div>
      </div>
    );
    MiddleBlock.push(
      <div className='schedule__block'>
        <div className='schedule__color-block'>
          <div className=''>
            <div className='room-event__event'>
              <div className='room-event__title room-event__title_color room-event__title_mode'>Смена 1: общение на стендах компаний</div>
            </div>
          </div>
        </div>
        <div key='3'>

          <div key='0' className='schedule__event schedule__event_not-padding'></div>
          <div key='1' className='schedule__event schedule__event_min'>
            <div className='schedule__time'>15:40 - 15:55</div>
            <div className='schedule__room-event schedule__room-event_right'>
              <div className='room-event__speaker'>
                <a href={'/speaker?id=1068'} className='room-event__speaker-link'>Марина Пайч,</a>
              </div>
              <div className='room-event__speaker-job-position'>
                <a target='_blank' className='room-event__speaker-job-link' href='http://www.adcisolutions.com/'>ADCI Solutions</a>
                , Руководитель направления организационного развития
                , Омск
              </div>
              <div className='room-event__event'>
                <a href='/room-event/155' className='room-event__title-link'>Омская IT-тусовка</a>
              </div>
            </div>
          </div>
          <div key='2' className='schedule__event schedule__event_min'>
            <div className='schedule__time'>15:55 - 16:10</div>
            <div className='schedule__room-event schedule__room-event_right'>
              <div className='room-event__speaker'>
                <a href={'/speaker?id=1083'} className='room-event__speaker-link'>Александр Мишурин,</a>
              </div>
              <div className='room-event__speaker-job-position'>
                <a target='_blank' className='room-event__speaker-job-link' href='http://aciso.ru/'>МРОО «АРСИБ»</a>
                , Член АРСИБ
                , Омск
              </div>
              <div className='room-event__event'>
                <a href='/room-event/170' className='room-event__title-link'>Развитие CTF-движения в Омске</a>
              </div>
            </div>
          </div>
          <div key='3' className='schedule__event schedule__event_min'>
            <div className='schedule__time'>16:10 - 16:25</div>
            <div className='schedule__room-event schedule__room-event_right'>
              <div className='room-event__speaker'>
                <a href={'/speaker?id=1085'} className='room-event__speaker-link'>Сергей Савченко,</a>
              </div>
              <div className='room-event__speaker-job-position'>
                <a target='_blank' className='room-event__speaker-job-link' href='http://www.progschool.ru/_wp/'>ООО "Образование АйТи"</a>
                , Директор
                , Омск
              </div>
              <div className='room-event__event'>
                <a href='/room-event/172' className='room-event__title-link'>Школа программиста, учим детей и не только</a>
              </div>
            </div>
          </div>
          <div key='4' className='schedule__event schedule__event_min'>
            <div className='schedule__time'>16:25 - 16:40</div>
            <div className='schedule__room-event schedule__room-event_right'>
              <div className='room-event__event'>
                <div className='room-event__title'>Доклад уточняется</div>
              </div>
            </div>
          </div>

        </div>

      </div>
    );
    MiddleBlock.push(
      <div className='schedule__event schedule__event_not-padding'></div>
    )
    return MiddleBlock;
  }

  render() {
    let section = null;
    let location = null;
    if (this.props.sections.length > 0) {
      section = this.createScheduleBlock();
      location = this.props.sections[1].roomName;
    }
    // console.log(this.props.sections);
    return (
      <div className='schedule__container'>
        {/*<div className='schedule__location'>{location}</div>*/}
        <div>
          {section}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sections: state.schedule.sections
});

export default connect(mapStateToProps)(ScheduleSection);



// WEBPACK FOOTER //
// ./src/schedule-page/blocks/ScheduleSection.js